
const driver = [
  {
    path: '/driver',
    name: 'driver',
    component: () => import('@/views/wxapp/driver'),
    redirect: '/driver/list',
    meta: {
      title: '运输中'
    },
    children: [
      {
        path: 'list',
        name: 'driver-list',
        component: () => import('@/views/wxapp/driver/list'),
        meta: {
          title: '专车到户'
        }
      },
      {
        path: 'listDetails',
        name: 'list-details',
        component: () => import('@/views/wxapp/driver/list/listDetails'),
        meta: {
          title: '专车到户详情'
        }
      },
      {
        path: 'listNot',
        name: 'list-not',
        component: () => import('@/views/wxapp/driver/list/listNot'),
        meta: {
          title: '到货'
        }
      },
      {
        path: 'LessHome',
        name: 'Less-home',
        component: () => import('@/views/wxapp/driver/LessHome'),
        meta: {
          title: '专车不到户'
        }
      },
      {
        path: 'LessHomeDetails',
        name: 'Less-home-details',
        component: () => import('@/views/wxapp/driver/LessHome/LessHomeDetails'),
        meta: {
          title: '专车不到户详情'
        }
      },
      {
        path: 'LessHomeNot',
        name: 'Less-home-Not',
        component: () => import('@/views/wxapp/driver/LessHome/LessHomeNot'),
        meta: {
          title: '到货'
        }
      }
    ]
  }
]
export default driver
